var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../common/components/base.component';
var GpsRedirectComponent = /** @class */ (function (_super) {
    __extends(GpsRedirectComponent, _super);
    function GpsRedirectComponent(activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.activatedRoute = activatedRoute;
        navigator.geolocation.getCurrentPosition(function (position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            console.log("lat: " + lat + ", lng: " + lng);
            //let googleMapUrl = localStorage.getItem('gps-url');
            var locationString = _this.allRouteParams.locationString;
            var googleMapUrl = locationString;
            // googleMapUrl = googleMapUrl.replace(/(\|)+/g, "/");
            googleMapUrl = 'http://www.google.com/maps/dir/?api=1&' + googleMapUrl.replace('${GPS}', lat + "," + lng);
            window.location.href = googleMapUrl;
        }, function (error) {
            console.log('ERROR(' + error.code + '): ' + error.message);
            alert('Unable to retrieve your location!' + 'ERROR(' + error.code + '): ' + error.message);
        });
        return _this;
    }
    return GpsRedirectComponent;
}(BaseComponent));
export { GpsRedirectComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/gps.redirect.component.ts.pre-build-optimizer.js